import qs from 'qs'
import { debounce, empty } from './utils'
import SGMap from './SGMap'

const isRecruitingMap = ($) => !!$('[data-node-type="recruiting_map"]').get(0)

let mapInitialized = false
let sgMap

const showMapView = () => {
  if (mapInitialized) {
    return
  }
  mapInitialized = true
  const locations = $('[data-locations]').data('locations')

  sgMap = new SGMap(locations, 'recruiting', $('[data-job-listing-map]').get(0), $('[data-infobox-tmpl]').html())

  // click in info window link
  $('body').on('SGMap.filterByloctionID', function(e, locID) {
    $('jobs-modal').data('location_id', locID)
    searchByLocationURLAndID('', locID)
  })

  // marker clicked
  $('body').on('SGMap.markerClicked', function(e, { locationId }) {
    // sgMap.openWindowForLocationID(locationId)
  })

  $(document).on('click', '.jobs-modal .node-recruiting-map-listing-paqgination .pagination a', function(e) {
    e.preventDefault()
    const locID = $('jobs-modal').data('location_id')
    const url = $(this).attr('href')
    searchByLocationURLAndID(url, locID)
  })
}

const searchByLocationURLAndID = (url, locID) =>
  searchByLocationURL(`${url}?active_view=map&q[location_id_eq]=${locID}`)

// when location clicked on map
const searchByLocationURL = (url) => {
  const modal = $('.jobs-modal.three-slides')
  if (!modal.get(0)) {
    showModal('[data-modal-template-3]', url)
  }

  const q = `${url}`

  $.get(url, function(data) {
    const $data = $(data)
    const jobList = $data.find('[data-job-list]')
    jobList.find('.node-recruiting-map-listing-head').remove()

    $('[data-slide-1]').html(jobList.html())
    pushState(q.substr(1))
  })
}

// top LIST|MAP switch
const setupSwitchButtons = ($) => {
  $('[data-switch-button]').data('setup-switch-buttons-done', true)
  $('[data-switch-button]').on('click', function(e) {
    e.preventDefault()
    e.stopPropagation()

    if ($(this).hasClass('active')) {
      return
    }

    $('[data-switch-button]').toggleClass('active')

    const v = $($(this).data('switch-button'))
    v.toggleClass('hidden')

    $('.node-recruiting-map').attr('data-view-type', $(this).data('switch-view-type'))

    showMapView()
    const activeView = $(this).data('switch-view-type')
    pushState(`active_view=${activeView}`)
  })
}

const search = ($, f, url) => () => {
  f.addClass('loading')
  const q = f.serialize()

  $.get(`${url}?${q}`, (res) => {
    f.removeClass('loading')
    $('.node-recruiting-map-listing-jobs').html(res)
    pushState(q)
  })
}

const setupSearch = ($) => {
  const f = $('[data-job-search-form]')
  const url = $('[data-job-search-url]').data('job-search-url')
  const searchFunc = search($, f, url)
  $('[data-job-search-url] .search-q').on('keyup', debounce(searchFunc, 500))
  return searchFunc
}

const setupMobileSearch = ($) => {
  const f = $('[data-job-search-form-mobile]')
  const url = $('[data-job-search-url]').data('job-search-url')
  const searchFunc = search($, f, url)
  $('[data-job-search-form-mobile] .search-q').on('keyup', debounce(searchFunc, 500))
  // wire selects
  $('[data-job-search-form-mobile] select').on('change', function() {
    if (!empty($(this).val())) {
      $(this)
        .closest('.select-wrap')
        .addClass('selected')
    }
    searchFunc()
  })

  $(document).on('click', '[data-job-search-form-mobile] .select-wrap.selected .icon-x', function() {
    const w = $(this).closest('.select-wrap')
    w.removeClass('selected')
    $('select', w).val('')
    searchFunc()
  })

  $(document).on('click', '.node-recruiting-map .toggle-filters-x', function() {
    // check if filters are present
    setMobileSearchState($)
  })

  return searchFunc
}

// set mobile sercha state  filter icon and select x icons
const setMobileSearchState = ($) => {
  // set filters to active icon
  if (mobileSearchIsEmpty($)) {
    $('.node-recruiting-map-top .mobile .toggle-filters').removeClass('has-filters')
  } else {
    $('.node-recruiting-map-top .mobile .toggle-filters').addClass('has-filters')
  }
  // restore x icons for selects
  const sels = [
    '#q_location_country_code_eq',
    '#q_location_division_id_eq',
    '#q_job_type_id_eq',
    '#q_job_business_id_eq',
  ]

  sels.forEach((sel) => {
    const fullSel = `.node-recruiting-map-listing-head.mobile ${sel}`
    const $select = $(fullSel)
    if (!empty($select.val())) {
      // show the x icon
      $select.closest('.select-wrap').addClass('selected')
    }
  })
}
const mobileSearchIsEmpty = ($) =>
  $('.node-recruiting-map-listing-head.mobile #q_location_country_code_eq').val() === '' &&
  $('.node-recruiting-map-listing-head.mobile #q_location_division_id_eq').val() === '' &&
  $('.node-recruiting-map-listing-head.mobile #q_job_type_id_eq').val() === '' &&
  $('.node-recruiting-map-listing-head.mobile #q_job_business_id_eq').val() === '' &&
  $('.node-recruiting-map-listing-head.mobile input[name="query"]').val() === ''

const loadJobDetail = (jobURL, modal) => {
  $.get(jobURL, function(data) {
    const $data = $(data)
    const newJobApplcationURL = $data.find('[data-new-job-applcation-url]').data('new-job-applcation-url')
    const slides = modal.data('slides')
    $(`[data-slide-${slides - 1}]`).html(
      $data
        .find('[data-job-id]')
        .parent()
        .html()
    )

    $('#job-apply-iframe').attr('src', newJobApplcationURL)

    const locations = $('[data-locations]', modal).data('locations')
    // TODO: destroy ?
    new SGMap(locations, 'recruiting', '[data-map="job-detail"]', $('[data-infobox-single-tmpl]').get(0))

    pushState(`jobURL=${jobURL}`)
  })
}

const closeModal = (e) => {
  setTimeout(function() {
    $('body')
      .removeAttr('scroll')
      .css({ overflow: 'auto' })
    e.remove()
  }, 500)

  $('.jobs-modal-background, .jobs-modal-pane').addClass('enter')

  if (history.pushState) {
    // history.replaceState({}, docTitle, docHref)
    // history.back()
  }
}

const showModal = (sel, jobURL) => {
  $('.jobs-modal').remove()
  // template
  const mhtml = $(sel).html()
  const modal = $(mhtml).appendTo('body')

  const bg = modal.find('.jobs-modal-background')
  // background close
  bg.on('click', () => closeModal(modal))
  // close btn
  $('[data-dismiss="modal"]', modal).on('click', () => closeModal(modal))

  // dont scroll on body
  $('body')
    .attr('scroll', 'no')
    .css({ overflow: 'hidden' })

  // animation
  setTimeout(function() {
    $('.enter', modal).removeClass('enter')
  }, 1)

  // slide to apply Button
  $(modal).on('click', '[data-job-apply-button]', (e) => {
    e.preventDefault()
    showNextSlide()
  })

  // slide back Button
  $('.back', modal).on('click', (e) => {
    e.preventDefault()
    showPrevSlide()
  })

  showSlide(1)
  return modal
}

const showSlide = (n) => {
  $('.jobs-modal')
    .data('slide', n)
    .removeClass('slide-1')
    .removeClass('slide-2')
    .removeClass('slide-3')
    .addClass(`slide-${n}`)
}

const showNextSlide = (n) => {
  showSlide($('.jobs-modal').data('slide') + 1)
}

const showPrevSlide = (n) => {
  showSlide($('.jobs-modal').data('slide') - 1)
}

const pushState = (q) => {
  if ('pushState' in history) {
    const html = $('.node-recruiting-map .node-recruiting-map-listing-jobs').html()

    history.pushState({ type: 'recruiting_map', q, html }, '' + document.title, `?${q}`)
  }
}

const setupPopstate = ($) => {
  window.onpopstate = function(event) {
    if (event.state && typeof event.state === 'object' && event.state.type === 'recruiting_map') {
      $('.node-recruiting-map .node-recruiting-map-listing-jobs').html(event.state.html)
    }
  }
}

const setMapState = ($) => {
  const { q } = qs.parse(`${location.search}`.substr(1))
  // debugger
  if (q && 'location_id_eq' in q) {
    sgMap.openWindowForLocationID(q.location_id_eq)
    searchByLocationURLAndID('', q.location_id_eq)
  }
}

const setup = ($) => {
  if (!isRecruitingMap($)) {
    return
  }
  setupSwitchButtons($)
  setupMobileSearch($)
  setMobileSearchState($)

  const searchFunc = setupSearch($)

  $('[data-toggle-hidden]').on('click', function() {
    $($(this).data('toggle-hidden')).toggleClass('hidden')
  })

  // click on job main window
  $(document).on('click', '.node.node-recruiting-map [data-job-url]', function(e) {
    e.preventDefault()
    e.stopPropagation()
    // load job
    const jobURL = $(this).data('job-url')

    if (window.innerWidth < 768) {
      location.href = jobURL
      return
    }

    const modal = showModal('[data-modal-template-2]', jobURL)
    loadJobDetail(jobURL, modal)
  })

  // click on job modal
  $(document).on('click', '.jobs-modal [data-job-url]', function(e) {
    e.preventDefault()
    e.stopPropagation()
    // load job
    const jobURL = $(this).data('job-url')
    // slide 2
    showSlide(2)

    const modal = $('.jobs-modal')
    loadJobDetail(jobURL, modal)
  })

  // connect select to form fields
  $('.sg.select').on('change', (e, valObj) => {
    $(`input[name="${valObj.name}"]`).val(valObj.value)
    searchFunc()
  })

  // check for view=map
  if (`${location.search}`.match(/active_view=map/)) {
    showMapView()
    $('[data-switch-view-type="map"]').trigger('click')
    setMapState($)
  }

  // check for jobURL=/en/career/...
  if (`${location.search}`.match(/jobURL=[^&]+/)) {
    const qObj = qs.parse(location.search.substr(1))
    const modal = showModal('[data-modal-template-2]', qObj.jobURL)
    loadJobDetail(qObj.jobURL, modal)
  }
}

export default setup



// WEBPACK FOOTER //
// app/javascript/sg/js/node_recruiting_map.js